import moment from 'moment';

import { colors } from '@styleseat/brand';
import stateManager from '../../../../../modules/user/stateManager';
import FeatureFlags from '../../../../../modules/FeatureFlags';

import analytics from '../../../../../modules/analytics';

import { InsightCardProps, InsightCardFactoryProps } from '../../Components/InsightCards/types';

import { CARD_TYPES } from '../../Components/InsightCards/cards/InsightCardFactory';
import { INSIGHT_ACTION_PREFIX } from '../../../MarketingUtils/constants';
import { InsightModel } from '../types';
import { MARKETING_TIP_SOURCE } from '../routing';

export const SWITCH_NAME = 'provider_marketing_tips_fly2981_20210515';
export const ACTION_TYPE = 'lastMinuteAvailability';
export const ACTION_PREFIX = `${INSIGHT_ACTION_PREFIX}last-minute-availability-`;

/**
 * parseCardData - parse data it into InsightCardProps
 * and return the results
 *
 * @param providerId
 * @returns : MarqueeCarProps
 */
const parseCardData = (providerId, cardIndex): InsightCardProps => ({
  id: 'marketing-tips-adjust-booking-availability-insight',
  headline: 'Adjust your online booking notice to be',
  subhead: '8 hours or less',
  subheadColor: colors.slate,
  bodyText: [
    {
      text: 'New clients are',
    },
    {
      text: '50% more likely',
      color: colors.slate,
    },
    {
      text: 'to search for and book same day appointments',
    },
  ],
  cta: 'adjust booking notice',
  clickThroughData: {
    route: 'provider.settings_menu.online_booking.online_booking',
    params: {
      providerId,
      source: MARKETING_TIP_SOURCE,
    },
  },
  analyticsData: {
    event: 'pro_home_last_min_availability_grow_click',
    payload: {
      providerId,
    },
  },
  firstViewTracking: () => analytics.track('pro_home_last_min_availability_grow_view', { card_index: cardIndex }),
  onAction: () => analytics.track('pro_home_last_min_availability_grow_complete', { timestamp: moment().toISOString() }),
  timeToComplete: '30 seconds',
});

export const getInsights = async (): Promise<InsightModel> => {
  const enabled = await FeatureFlags.getFlagValue(SWITCH_NAME);

  try {
    const lastMinuteAvailAction = await stateManager.getActionValue(`${ACTION_PREFIX}complete`);
    return lastMinuteAvailAction || !enabled
      ? null
      : {
        insight_type: 'lastMinuteAvailability',
      };
  } catch (error) {
    return null;
  }
};

export const parseLastMinuteAvailabilityInsight = (
  provider, insight, updateState, user, metrics, cardIndex,
):
InsightCardFactoryProps => ({
  type: CARD_TYPES.inlineHeadline,
  cardProps: parseCardData(provider.id, cardIndex),
});
